

import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useEffect, useState } from 'react';
import {IDoctor, IDoctorSearch } from "../models/Doctor";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import useSchoolYearService, { useBasicFilterSchoolYear } from 'features/setup/services/SchoolYear';

import { currentUserSessionAtom } from 'library/store';
import { isNumber, toNumber } from 'lodash';
import { useQuery } from 'react-query';
import { ISchoolYear } from 'features/setup/models/SchoolYear';
import { EventInput } from '@fullcalendar/core';


const _ = () => {

    const axios = useAxios(); 

    //const {schoolYears} = useRecoilValue(currentUserSessionAtom);    

    const createDoctor = async (doctor: IDoctor)  =>       
        await (await axios.post('/api/setup/doctor/create', doctor)).data;       
        
    const updateDoctor = async (doctor: IDoctor)  =>       
        await (await axios.post('/api/setup/doctor/update', doctor)).data; 
    
    const getDoctor = async (id  : number )  => {
      const {data} = (await axios.get(`/api/setup/doctor/get-doctor/${id}`));
      return await data;
    }
   
    const getDoctors = async (criteria: IDoctorSearch, pagination?: IPagination) : Promise<IDoctor[]> => {

      const {firstName, lastName, email, portable } = criteria;const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;
      
      const {data} = (await axios.get(`/api/setup/doctor/get-doctors?firstName=${firstName}&lastName=${lastName}&portable=${portable}&email=${email}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }

    
      
      
    return {    
      createDoctor,
      updateDoctor,
      getDoctor,
      getDoctors,

      
    } 
}

export default _;

export interface IFilterDoctorOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [IDoctor[], React.Dispatch<React.SetStateAction<IDoctor[]>>],
}

const defaultFilterDoctorOption: IFilterDoctorOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterDoctor = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IDoctor) => void,
                    filterOption?: IFilterDoctorOption  ) => {

  const { getDoctors } = _();

  const { t, i18n } = useTranslation();   
  const {language: lg, applicationSetup } = useRecoilValue(currentUserSessionAtom);
  
  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterDoctorOption;

  
  const [headDoctorCells, setHeadDoctorCells]  = useState<HeadCell<IDoctor>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 5 },    

    {id:lg.includes('en')?'firstName':'lastName', label : lg.includes('en')?t('First name'):t('Last name'),  display: true, type: 'string', width: 20 },
    {id:lg.includes('en')?'lastName':'firstName', label : lg.includes('en')?t('Last name'):t('First name'),  display: true, type: 'string', width: 20},

    {id:'portable1', label : t('Portable'),  display: true, type: 'string', width: 15},
    {id:'email1', label : t('Email'),  display: true, type: 'string', width: 20},

    {id:'licenseNumber', label : t('Regis. Number'),  display: true, type: 'string', width: 10},
    
  ]); 
  
  const [filterElements,setFilterElements] = useState<ITextFilterElement[]>([         
        
    {name: 'firstName', text: t('First name'), value: ''},
    {name: 'lastName', text: t('Last name'), value: ''},           
    {name: 'portable', text: t('Portable'), value: ''},
    {name: 'email', text: t('Email'), value: ''},     
  ]);
  
  const [filteredDoctors, ] = useState<IDoctor[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IDoctor[]> => {
        
    const firstName = filterElements.find( elt => elt.name === 'firstName')?.value || '';
    const lastName = filterElements.find( elt => elt.name === 'lastName')?.value || '';  
    const portable = filterElements.find( elt => elt.name === 'portable')?.value || '';
    const email = filterElements.find( elt => elt.name === 'email')?.value || '';  
    
    const arr = await getDoctors( {firstName,lastName, portable, email}, pagination );
   
    return arr;
  }

  const objKey: keyof IDoctor = 'id';

  return {
    title: t('Doctor'), headCells: headDoctorCells, objKey,
    filterElements, rows: filteredDoctors, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
